import React, { useState } from "react";
import PropTypes from "prop-types";
import "../dashboard/css/Cities.css";
import mumbai from "../dashboard/assets/mumbai.webp";
import ahmedabad from "../dashboard/assets/ahmedabad.webp";
import surat from "../dashboard/assets/surat.webp";
import vadodara from "../dashboard/assets/vadodara.jpg";
import delhi from "../dashboard/assets/delhi.webp";
import bangalore from "../dashboard/assets/bangalore.webp";
import pune from "../dashboard/assets/pune.webp";
import kolkata from "../dashboard/assets/kolkata.webp";

const Cities = ({ activeCity = "Vadodara" }) => {
  const [showMessage, setShowMessage] = useState(false);
  const [messageText, setMessageText] = useState("");

  const cities = [
    { name: "Mumbai", image: mumbai },
    { name: "Ahmedabad", image: ahmedabad },
    { name: "Surat", image: surat },
    { name: "Vadodara", image: vadodara },
    { name: "Delhi", image: delhi },
    { name: "Bangalore", image: bangalore },
    { name: "Pune", image: pune },
    { name: "Kolkata", image: kolkata },
  ];

  const handleCityClick = (cityName) => {
    if (cityName === activeCity) {
      setMessageText(`You have already selected ${activeCity} as your city.`);
      setShowMessage(true);
    } else {
      setMessageText(`${cityName} listings are coming soon.`);
      setShowMessage(true);
    }
  };

  return (
    <div className="cities-section">
      <div className="cities-header">
        <h2 className="cities-title">Discover Major Cities</h2>
        <p className="cities-subtitle">Top Cities</p>
      </div>

      <div className="cities-grid">
        {cities.map((city, index) => (
          <div
            key={index}
            className="city-card"
            onClick={() => handleCityClick(city.name)}
          >
            <img src={city.image} alt={city.name} className="city-image" />
            <p className="city-name">{city.name}</p>
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {showMessage && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button
              className="popup-close-btn"
              onClick={() => setShowMessage(false)}
              type="button"
            >
              ✕
            </button>

            <h3>{messageText.includes("already") ? "Info" : "Coming Soon"}</h3>
            <p
              style={{
                marginBottom: "20px",
                color: "#64748b",
                fontSize: "15px",
              }}
            >
              {messageText}
            </p>
            <button
              type="button"
              onClick={() => setShowMessage(false)}
              style={{
                width: "100%",
                background: "linear-gradient(135deg, #1677ff, #722ed1)",
                color: "white",
                border: "none",
                padding: "14px",
                borderRadius: "10px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

Cities.propTypes = {
  activeCity: PropTypes.string,
};

export default Cities;
